import App from './App.svelte';

new App({
	target: document.querySelector('#daily-menu'),
  })

export default app;